import { useEffect } from "react";

export const useFrameBusting = () => {
  useEffect(() => {
    if (window.self !== window.top) {
      try {
        window.top.location.href = window.self.location.href;
      } catch (error) {
        // When the portal is embedded in a sandboxed or cross-origin iframe,
        // the browser can block top-window navigation. In that case we keep
        // rendering in place instead of crashing the whole app.
      }
    }
  }, []);
};